import { usePut } from '../../HttpClient';
import { CalendarModel } from '@app/models';
import { referenceDataBaseUrl } from '../BaseUrls';
import { useMutationWithErrorHandling } from '../../../hooks/UseMutationWithErrorHandling';

export function useUpdateCalendar() {
  const put = usePut(true, "tms");
  const updateCalendar = (id: string, calendar: CalendarModel) =>
    put(`${referenceDataBaseUrl}/calendars/${id}`, calendar);
  return useMutationWithErrorHandling({
    mutationFn: async ({ id, calendar }: { id: string; calendar: CalendarModel }) => await updateCalendar(id, calendar),
  });
}
